import React from "react";
import './toggle-switch.scss';

interface IProps {
    isOn: boolean;
    update: () => void;
}

const ToggleSwitch: React.FC<IProps> = ({ isOn, update }) => {

    return (
        <label className="switch">
            <input type="checkbox" defaultChecked={isOn} onChange={() => update()} />
            <span className="slider"></span>
        </label>
    )
}

export default ToggleSwitch;